import React, { useEffect, useRef, useState } from "react";
import { CONTACT } from "../lib/site";
import { TikTokIcon } from "./FloatingWhatsApp";

const SCRIPT_SRC = "https://www.tiktok.com/embed.js";

export const TikTokEmbed = () => {
  const rootRef = useRef(null);
  const [near, setNear] = useState(false);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    const node = rootRef.current;
    if (!node) return;
    const obs = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setNear(true);
          obs.disconnect();
        }
      },
      { rootMargin: "500px" }
    );
    obs.observe(node);
    return () => obs.disconnect();
  }, []);

  useEffect(() => {
    if (!near) return;
    const existing = document.querySelector(`script[src="${SCRIPT_SRC}"]`);
    if (existing) {
      window.tiktok?.embed?.render?.();
      return;
    }
    const s = document.createElement("script");
    s.src = SCRIPT_SRC;
    s.async = true;
    s.onload = () => window.tiktok?.embed?.render?.();
    s.onerror = () => setFailed(true);
    document.body.appendChild(s);
  }, [near]);

  return (
    <div ref={rootRef} data-testid="tiktok-embed" className="mt-10 md:mt-14">
      <div className="mx-auto max-w-[605px] rounded-sm border border-white/10 bg-cream p-2 md:p-3 min-h-[400px]">
        {near ? (
          <blockquote
            className="tiktok-embed"
            cite={CONTACT.tiktok}
            data-unique-id="mammarosaypsoscorfu"
            data-embed-type="creator"
            style={{ maxWidth: "605px", minWidth: "288px", margin: 0 }}
          >
            <section>
              <a target="_blank" rel="noopener noreferrer" href={CONTACT.tiktok}>
                @mammarosaypsoscorfu
              </a>
            </section>
          </blockquote>
        ) : (
          <div className="h-[400px] animate-pulse bg-navy/5" />
        )}
      </div>
      <div className="mt-6 text-center">
        <a
          href={CONTACT.tiktok}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="tiktok-follow-btn"
          className="inline-flex items-center gap-2 rounded-full border border-cream/25 px-7 py-3 font-body text-sm text-cream hover:border-gold hover:text-gold transition-colors"
        >
          <TikTokIcon size={16} /> @mammarosaypsoscorfu
        </a>
        {failed && (
          <p data-testid="tiktok-fallback" className="mt-4 font-body text-sm text-cream/50">
            TikTok non disponibile al momento — guarda i video dal link qui sopra.
          </p>
        )}
      </div>
    </div>
  );
};
